import React, { useState, useEffect } from 'react';
import { settingsApi } from '../api/settings';

interface Props {
  branchName?: string;
  branchAddress?: string;
  branchPhone?: string;
  branchEmail?: string;
  documentTitle?: string;
}

let cachedCompany: any = null;

const DocumentHeader: React.FC<Props> = ({ branchName, branchAddress, branchPhone, branchEmail, documentTitle }) => {
  const [company, setCompany] = useState<any>(cachedCompany);

  useEffect(() => {
    if (cachedCompany) { setCompany(cachedCompany); return; }
    settingsApi.getCompany()
      .then(r => { cachedCompany = r.data.data; setCompany(cachedCompany); })
      .catch(() => {});
  }, []);

  if (!company) return null;

  const address = branchAddress || company.address || '';
  const phone   = branchPhone   || company.phone   || '';
  const email   = branchEmail   || company.email   || '';
  const contactLine = [phone ? 'Tel: ' + phone : '', email].filter(Boolean).join('  |  ');

  return (
    <div style={{ padding: '16px 24px', border: '2px solid var(--bdr)', borderRadius: 6, textAlign: 'center', marginBottom: 12 }}>
      <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: 0.5 }}>{company.name}</div>
      {branchName && <div style={{ fontSize: 13, fontWeight: 600, marginTop: 2 }}>{branchName}</div>}
      {address && <div style={{ fontSize: 12, color: 'var(--tx3)', marginTop: 2 }}>{address}</div>}
      {contactLine && <div style={{ fontSize: 12, color: 'var(--tx3)', marginTop: 2 }}>{contactLine}</div>}
      {company.tax_number && <div style={{ fontSize: 11, color: 'var(--tx3)', marginTop: 2 }}>Tax No: {company.tax_number}</div>}
      {documentTitle && <div style={{ fontSize: 14, fontWeight: 700, marginTop: 10, textTransform: 'uppercase', letterSpacing: 1 }}>{documentTitle}</div>}
    </div>
  );
};

export default DocumentHeader;
